import {
	GotoCleanLabelProducts,
	GotoKehe,
	GotoMinorityProducts,
	GotoNewtoMarketProducts,
	GotoNextyProducts,
	GotoPrivateProducts
} from '../Cta/Cta';
// import { SeeAll } from '../SeeAll/SeeAll';

export const Mobile = () => {
	return (
		<div className='newtopiaMobile'>
			<div className='cardContainer'>
				<div className='card cardPrivate'>
					<GotoPrivateProducts />
				</div>
				<div className='card cardLabel'>
					<GotoCleanLabelProducts />
				</div>
				<div className='card cardNexty'>
					<GotoNextyProducts />
				</div>
				<div className='card cardNewtoMarket'>
					<GotoNewtoMarketProducts />
				</div>
				<div className='card cardMinority'>
					<GotoMinorityProducts />
				</div>
				<div className='card cardKehe'>
					<GotoKehe />
				</div>
			</div>
			<div className='footer'></div>
		</div>
	);
};
